import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAPI } from 'data/api';
import { useListIntegrations } from 'src/hooks/useListIntegrations';

/**
 * List all installations for a project
 * @returns installations
 */
export const useListAllInstallations = () => {
  const getAPI = useAPI();
  const { projectId } = useParams();
  const { data: integrations } = useListIntegrations();

  return useQuery({
    queryKey: ['listAllInstallations', projectId, integrations?.map(i => i.id)],
    queryFn: async () => {
      if (!projectId || !integrations) throw new Error('projectId and integrations are required');
      const api = await getAPI();
      
      // Fetch installations for each integration
      const installationPromises = integrations.map(integration => 
        api.installationApi.listInstallations({ 
          projectIdOrName: projectId, 
          integrationId: integration.id 
        })
      );
      
      const installationsArrays = await Promise.all(installationPromises);
      return installationsArrays.flat();
    },
    enabled: !!projectId && !!integrations,
  });
};
